import { lazy } from 'react'

const AddProductLazy = lazy(() =>
  import(/* webpackChunkName: "AddProduct" */ './addProduct'),
)

export default AddProductLazy
